// extracted by mini-css-extract-plugin
export default {"alert":"Z_NLwnKKpP"};